// "use client";

// import useEmblaCarousel from "embla-carousel-react";
// import { Image } from "@heroui/image";
// import { cn } from "@heroui/theme";
// import { Icon } from "@iconify/react";

// import { Img34, Img35 } from "@/public/assets";

// const testimonials = [
//   {
//     text: "Cotton helped us hire the right people faster than we imagined, they truly understand our business needs.",
//     name: "ADA CHUKWU",
//     role: "HR MANAGER, TECHNOVA LTD.",
//     image: Img34.src,
//     bg: "bg-green-200 dark:bg-foreground-50",
//     imageClass: "object-[50%_10%] scale-125",
//   },
//   {
//     text: "Every candidate was prepared and ready to contribute from day one, making onboarding seamless.",
//     name: "EMMANUEL OKEKE",
//     role: "DIRECTOR, NEWA SOLUTIONS",
//     image: Img35.src,
//     bg: "bg-yellow-200 dark:bg-foreground-50",
//     imageClass: "scale-100",
//   },
// ];

// const TestimonialsSection = () => {
//   const [emblaRef] = useEmblaCarousel({ loop: true });

//   return (
//     <section className="bg-[#03160C] dark:bg-background text-white dark:text-foreground pt-[69px] pb-[88px] mb-10">
//       <div className="max-w-screen-2xl mx-auto lg:px-28 px-6">
//         {/* HEADER */}
//         <div className="mb-[49px] max-w-xl">
//           <div className="text-[32px] font-medium leading-10 tracking-[-0.16px] mb-[14px]">
//             We partner with companies to deliver talent that,{" "}
//             <span className="text-primary italic">fits, performs,</span>{" "}
//             and <span className="text-primary italic">stays.</span>
//           </div>

//           <p className="text-sm text-white dark:text-foreground-600 font-normal leading-5 tracking-[-0.084px]">
//             Hear directly from the businesses who've experienced the difference.
//           </p>
//         </div>
//       </div>

//       {/* CAROUSEL */}
//       <div className="md:ml-28 ml-6 max-sm:ml-4 mb-6" data-aos="fade-left">
//         <div ref={emblaRef} className="overflow-hidden">
//           <div className="flex gap-6">
//             {testimonials.map((item, i) => (
//               <div
//                 key={i}
//                 className={`rounded-2xl overflow-hidden grid grid-cols-2 items-end ${item.bg} py-1 pr-1 pl-4 gap-4 w-6/12`}
//               >
//                 <div className="mb-5">
//                   <p className="text-black dark:text-foreground-950 text-[22px] font-medium leading-[32px] mb-4 max-w-xs pr-16">
//                     {item.text}
//                   </p>

//                   <div className="text-black dark:text-foreground-600 text-xs font-normal leading-4 tracking-[0.48px] uppercase">
//                     <p>
//                       {item.name} - {item.role}
//                     </p>
//                   </div>
//                 </div>

//                 <div className="overflow-hidden h-[313px] rounded-2xl">
//                   <Image
//                     removeWrapper
//                     alt={item.name}
//                     className={cn(
//                       "object-cover w-full h-full rounded-2xl object-[50%_10%] scale-125",
//                       item.imageClass,
//                     )}
//                     src={item.image}
//                   />
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* FOOTER TAGS */}
//       <div className="flex flex-wrap font-normal uppercase gap-10 text-xs text-white dark:text-foreground max-w-screen-2xl mx-auto lg:px-28 px-6">
//         {[
//           "100% VALUE",
//           "100% PEACE OF MIND",
//           "VETTED PROFESSIONALS",
//           "INDEMNITY",
//           "100% COTTON",
//         ].map((item, i) => (
//           <div key={i} className="flex items-center gap-2 tracking-[0.84px]">
//             <Icon
//               className="text-primary text-2xl"
//               icon="codicon:verified-filled"
//             />
//             {item}
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default TestimonialsSection;

"use client";

import useEmblaCarousel from "embla-carousel-react";
import { Image } from "@heroui/image";
import { cn } from "@heroui/theme";
import { Icon } from "@iconify/react";

import { Img34, Img35 } from "@/public/assets";

const testimonials = [
  {
    text: "Cotton helped us hire the right people faster than we imagined, they truly understand our business needs.",
    name: "ADA CHUKWU",
    role: "HR MANAGER, TECHNOVA LTD.",
    image: Img34.src,
    bg: "bg-green-200 dark:bg-foreground-50",
    imageClass: "object-[50%_10%] scale-125",
  },
  {
    text: "Every candidate was prepared and ready to contribute from day one, making onboarding seamless.",
    name: "EMMANUEL OKEKE",
    role: "DIRECTOR, NEWA SOLUTIONS",
    image: Img35.src,
    bg: "bg-yellow-200 dark:bg-foreground-50",
    imageClass: "scale-100",
  },
];

const TestimonialsSection = () => {
  const [emblaRef] = useEmblaCarousel({ loop: true });

  return (
    <section className="bg-[#03160C] dark:bg-background text-white dark:text-foreground pt-[50px] sm:pt-[60px] md:pt-[69px] pb-[60px] sm:pb-[70px] md:pb-[88px] mb-10">
      <div className="max-w-screen-2xl mx-auto lg:px-28 px-4 sm:px-6">
        {/* HEADER */}
        <div
          className="mb-[30px] sm:mb-[40px] md:mb-[49px] max-w-xl"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <div className="text-[24px] sm:text-[28px] md:text-[32px] font-medium leading-8 sm:leading-9 md:leading-10 tracking-[-0.16px] mb-[10px] sm:mb-[14px]">
            We partner with companies to deliver talent that{" "}
            <span className="text-primary italic">fits, performs,</span> and{" "}
            <span className="text-primary italic">stays.</span>
          </div>

          <p className="text-xs sm:text-sm text-white dark:text-foreground-600 font-normal leading-5 tracking-[-0.084px]">
            Hear directly from the businesses who've experienced the difference.
          </p>
        </div>
      </div>

      {/* CAROUSEL */}
      <div
        className="md:ml-28 ml-4 sm:ml-6 mb-6"
        data-aos="fade-left"
        data-aos-delay="200"
      >
        <div ref={emblaRef} className="overflow-hidden">
          <div className="flex gap-4 sm:gap-6">
            {testimonials.map((item, i) => (
              <div
                key={i}
                className={`rounded-2xl overflow-hidden grid grid-cols-1 sm:grid-cols-2 items-end ${item.bg} py-2 sm:py-1 pr-2 sm:pr-1 pl-4 gap-4 w-[85%] sm:w-[70%] md:w-6/12 flex-shrink-0`}
              >
                <div className="mb-4 sm:mb-5">
                  <p className="text-black dark:text-foreground-950 text-[16px] sm:text-[18px] md:text-[22px] font-medium leading-6 sm:leading-7 md:leading-[32px] mb-3 sm:mb-4 max-w-xs pr-0 sm:pr-10 md:pr-16">
                    {item.text}
                  </p>

                  <div className="text-black dark:text-foreground-600 text-[10px] sm:text-xs font-normal leading-4 tracking-[0.48px] uppercase">
                    <p>
                      {item.name} - {item.role}
                    </p>
                  </div>
                </div>

                <div className="overflow-hidden h-[200px] sm:h-[260px] md:h-[313px] rounded-2xl">
                  <Image
                    removeWrapper
                    alt={item.name}
                    className={cn(
                      "object-cover w-full h-full rounded-2xl object-[50%_10%] scale-125",
                      item.imageClass,
                    )}
                    src={item.image}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* FOOTER TAGS */}
      <div
        className="flex flex-wrap justify-center md:justify-start font-normal uppercase gap-6 sm:gap-8 md:gap-10 text-[10px] sm:text-xs text-white dark:text-foreground max-w-screen-2xl mx-auto lg:px-28 px-4 sm:px-6"
        data-aos="fade-up"
        data-aos-delay="300"
      >
        {[
          "100% VALUE",
          "100% PEACE OF MIND",
          "VETTED PROFESSIONALS",
          "INDEMNITY",
          "100% COTTON",
        ].map((item, i) => (
          <div key={i} className="flex items-center gap-2 tracking-[0.84px]">
            <Icon
              className="text-primary text-lg sm:text-xl md:text-2xl"
              icon="codicon:verified-filled"
            />
            {item}
          </div>
        ))}
      </div>
    </section>
  );
};

export default TestimonialsSection;
